import { useState, useEffect } from 'react'
import styled from '@emotion/styled';
import { TopDisplay,Loading } from '../../../../ui-components';
import apiCall from '../../../../utils/apiCall';
import styles from '../../Applicants/css/display-applicant.module.css';
import { useQuery } from '@tanstack/react-query';
// import  {CreateBtn} from './CreateButton'
import CreateBtn from '../Induction/CreateButton';
import { useSettingModal } from '../../../../hooks/Context';
import ViewDetails from './ViewDetails';
import {FiMoreHorizontal as MoreIcon} from 'react-icons/fi';
import {MdOutlineArrowBackIosNew as LBtn,MdOutlineArrowForwardIos as RBtn} from 'react-icons/md';
import { convertTimetoString } from '../../../../helperFunction';
import {AiOutlineSearch as SearchIcon} from 'react-icons/ai';
import {IoReload as ReloadIcon} from 'react-icons/io5';
import { CircularProgress } from '@mui/material';
import { AxiosError } from 'axios';
import EditInduction from './UpdateInduction';


interface InductionResponse {
  InductionId: number;
  InductionName: string;
  InductionDate: string;
  InductionVenue: string;
  IsActive: boolean;
}

interface RoleList {
  Roles: string[];
}

let start = false;

const Induction = () => {
  const [searchData, setSearchData] = useState('')

  const getInduction = async (): Promise<InductionResponse[]> => {
    return (await apiCall().get('/SetUp/GetAllInduction')).data?.Data;
  };

  const {data, isFetching, isError, error} = useQuery(['all-Induction' ,searchData], getInduction, {
    retry: 0,
    keepPreviousData: true,
    enabled: true,
  });

  const getAllInductionErrorMessage = (error as AxiosError)?.message

  const filteredData = data?.filter(x => (
    Object.values(x).join(" ").toLowerCase().includes(searchData.toLowerCase())
  ));


  return (
    <Container>
      <TopDisplay title="Induction" subTitle="All" Btn={<CreateBtn />} />
      <InnerContainer >
        <label className={styles.searchForm} >
            <span className={styles.sI}><SearchIcon/></span>
            <input value = {searchData} onChange={(e) => setSearchData(e.target.value)} type="text" placeholder='Search' />
            <button className={styles.rBtn} type="submit">
                <ReloadIcon/>
            </button>
        </label>
        {/* <FilterDropDown onChange={setSelFilter} options={roleData} text="Route" bg="#11643C" color="#fff" /> */}
        {/* <FilterDropDown options={statusOpt} text="Status" bg="#E2E4E9"/> */}
      </InnerContainer>
      { isFetching ?
      (<CircularProgress 
                    sx={{
                      fontSize: '1rem',
                      marginInline: 'auto',
                      display: 'block',
                      marginBlock: '2rem'
                    }}
                  />
              ) : isError ? (
                  <StyledError>{getAllInductionErrorMessage}</StyledError>
              ) : 
      <InductionInvitesTable data={searchData.length > 0 ? filteredData : data} />}

    </Container>
  )
}
export default Induction;

export const Container = styled.div`
  padding: 0 20px 20px;
  width:100%;
`
export const InnerContainer = styled.div`
  display: flex;
  gap:10px;
  margin-top:20px;
`
const StyledError = styled('p')`
  color: red;
  font-size: 1.4rem;
  display: flex;
`
export const InductionInvitesTable = (props:any) =>{
  const [activeData,setActiveData] = useState<any>([]);
  const [pageData,setPageData] = useState<any>([]);
  const [currentPage,setCurrentPage] = useState<number>(0);
  const [pageArr,setPageArr] = useState<any>([]);
  const [showMore,setShowMore] = useState<boolean>(false);
  const [showIndex,setShowIndex] = useState<any>(null);
  const [showSpan,setShowSpan] = useState<boolean>(false);
  const [spanIndex,setSpanIndex] = useState<null | number>(null);
  const {setShowModal,setModalContent} = useSettingModal()
  const data:any = props.data || [];

//   const data = [
//     {
//       Name: 'Inducting 2023 set',
//       Venue: 'first Name',
//       Date: 'Last Name',
//       Time: 'Certificate Score',
//     }
//   ]


const handlePrevious = () => {
    if(currentPage === 0){
        if(pageArr.length > 1){
            setCurrentPage(pageArr.at(-1))
            return false;
        }
        setCurrentPage(0);
        return false;
    }
    setCurrentPage(currentPage-1);
  };

  const handleNext = () => {
    if(pageArr.length > 1){
      if(currentPage === pageArr.at(-1)) {
          setCurrentPage(0);
          return false;
      }
      setCurrentPage(currentPage+1);
      return false;
    }
    setCurrentPage(0);
  }


  const handleMore = (index:number) =>{
      if(index == showIndex){
          setShowIndex(null);
          setShowMore(false);
          return
      }
      setShowIndex(index);
      setShowMore(true);
  }
  const handleSpan = (index:number) =>{
      if(index == spanIndex){
          setSpanIndex(null);
          setShowSpan(false);
          return
      }
      setSpanIndex(index);
      setShowSpan(true);
  }

  const handleViewDetails =(data:any)=>{
      setModalContent(<ViewDetails data={data} />);
      setShowModal(true);
  }
  const handleEditInduction = (data: any) => {
  setModalContent(<EditInduction induction={data} />);
  setShowModal(true);
};

//   const handleApproveOrDecline=(data:any)=>{
      
//   }

  const DATA_PER_PAGE = 10;

  useEffect(()=>{
      if(data && data.length > 0){
          setActiveData(data);
          let lastPage = Math.ceil(data.length/10);
          let i = 0;
          let arr = [];
          for(i = 0;i<lastPage;i++){
              arr.push(i);
          }
          setPageArr(arr);
          setPageData(data.slice(0,DATA_PER_PAGE));
  
      }
  },[])

  useEffect(()=>{
      if(activeData && activeData.length > 0){    
          let start = currentPage*DATA_PER_PAGE;
          let stop = start+DATA_PER_PAGE;
          setPageData(data.slice(start,stop));  
      }
  },[currentPage])

  return (
      <Wrapper style={{width:'100%',marginTop:'15px'}}>
          <>
              <div style={{gridTemplateColumns:`repeat(5,1fr)`}}>
                  <div>Name</div>
                  <div>Venue</div>
                  <div>Date</div>
                  <div>Time</div> 
                  <div>Status</div> 

              </div>
              <div>
                  {pageData && pageData.length > 0 && pageData.map((eData:any,index:number):any =>
                    <div key={index} style={{gridTemplateColumns:`repeat(5,1fr)`}}>
                        <div onClick={() => handleSpan(index)}>{eData.InductionName}</div>
                        <div onClick={() => handleSpan(index)}>{eData.InductionVenue}</div>
                        <div onClick={() => handleSpan(index)}>{
                            convertTimetoString(eData.InductionDate,0) 
                        }</div>
                        <div>
                          <div onClick={()=>handleSpan(index)}>{
                            convertTimetoString(eData.InductionDate,1).split('|')[1] 
                          }</div> 
                        <div onClick={() => handleSpan(index)}>{eData.IsActive?'True':'False'}</div>

                            
                          <span  className={`moreSpan ${index == showIndex?`activeMore`:''} `} onClick={()=>handleMore(index)}><MoreIcon />
                              {index == showIndex && showMore ?<div>
                                  <div onClick={() => handleViewDetails(eData)}>View Details</div>
                                  <div onClick={() => handleEditInduction(eData)}>Edit Induction</div>

                                  
                              </div> : ''}
                          </span>
                        </div>
                    </div>
                  )}
              </div>
              <div className={'pagination'}>
                  <div>
                      <button onClick = {handlePrevious} className={`lBtn btn`}><LBtn/></button>
                      {pageArr && pageArr.length > 0 && pageArr.map((ePage: number, index: number) => {

                        if(index <= 4 && currentPage <= 4) return (<span
                            style={ ePage == currentPage ? {backgroundColor : "var(--activeP-back)", color : "var(--white-color)"} : {} } 
                            key={ePage} 
                            onClick={() => setCurrentPage(ePage)}
                        >
                            {ePage + 1}
                        </span>)  

                        if(index == currentPage ) return (<span
                            style={ ePage == currentPage ? {backgroundColor : "var(--activeP-back)", color : "var(--white-color)"} : {} } 
                            key={ePage} 
                            onClick={() => setCurrentPage(ePage)}
                        >
                            {ePage + 1}
                        </span>)  

                        if(index >= pageArr.length - 3 && currentPage >= pageArr.length -3) return (<span
                            style={ ePage == currentPage ? {backgroundColor : "var(--activeP-back)", color : "var(--white-color)"} : {} } 
                            key={ePage} 
                            onClick={() => setCurrentPage(ePage)}
                        >
                            {ePage + 1}
                        </span>)  

                        if(index == pageArr.length-1 && pageArr?.length > 5) return (
                        <>
                            <>...</>
                            <span 
                            style={ ePage == currentPage ? {backgroundColor : "var(--activeP-back)", color : "var(--white-color)"} : {} } 
                            key={ePage} 
                            onClick={() => setCurrentPage(ePage)}
                            >
                                {ePage + 1}
                            </span>
                        </>
                        )  

                        if(index == 0 && pageArr?.length > 5) return (
                        <>
                            <span 
                            style={ ePage == currentPage ? {backgroundColor : "var(--activeP-back)", color : "var(--white-color)"} : {} } 
                            key={ePage} 
                            onClick={() => setCurrentPage(ePage)}
                            >
                                {ePage + 1}
                            </span>
                            <>...</>
                        </>)  

                        })} 
                      <button onClick = {handleNext} className={`rBtn btn`}><RBtn/></button>
                  </div>
              </div>
          </>
          
      </Wrapper>
  )
}

const Wrapper = styled.div`

    display: flex;
    flex-direction: column;
    gap:10px;
    min-height: 450px;

 & > div:first-of-type{
    width: 100%;
    display:grid;
    border-bottom: 2px solid #E2E4E9;
    padding-bottom: 15px;
    gap:5px;
}
 & > div:first-of-type > *{
    color:#0F324D;
    font-size: 12px;
    font-weight: 500;
}
 & > div:nth-child(2){
    width: 100%;
    display: flex;
    flex-direction: column;
    gap:5px;
}
 &> div:nth-child(2) > *{
    flex:1;
    display:grid;
    gap:5px;
    border-left: 2px solid white;
    /* cursor: pointer; */
} &> div:nth-child(2) > *:hover{
    background-color: #E0FAEE;
    border-left-color:#293856;
}
 &> div:nth-child(2) > * > div{
    padding:10px 6px;
    text-overflow: ellipsis;
    /* overflow:hidden; */
    font-size: 12px;
   
}
 & > div:nth-child(2) > * > div:last-child{
    display:flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
}
 & > div:nth-child(2) > * > div:last-child > span{
    position: absolute;
    right:50px;
    background-color: var(--text-green);
    color:var(--white-color);
    padding:5px;
    border-radius: 2px;
    height: 20px;
    cursor: pointer;
    justify-content: center;
    align-items: center;
    display: none;
}
 & > div:nth-child(2) > * > .moreSpan{
    
    font-size: 16px;
    position: relative;
    
} & > div:nth-child(2) > *:hover > div:last-child > span{
    display: flex;
}
 & > div:nth-child(2) > * > div:last-child > span.activeMore{
    display:flex !important;
}

& .moreSpan > div{
    position: absolute;
    width:180px;
    display: flex;
    flex-direction: column;
    padding:10px 0;
    right:0;
    top:15px;
    z-index: 1;
    background-color: var(--white-color);
    border:1px solid #999;
    border-radius: 3px;
    color:#222;
}
& .moreSpan > div > div{
    flex:1;
    padding:5px 20px;
    font-size:13px ;
}
& .moreSpan > div > div:hover{
    background-color:#F1F1F1;
    ;
}

& .pagination{
    margin-top: auto;
    width: 100%;
    border-top: 2px solid #E2E4E9;
    padding: 10px;
    display: flex;
    justify-content: flex-end;
}
& .pagination > div{
    position: relative;
    display: flex;
    flex-wrap: wrap;
    gap:8px;
    padding:0 30px;;
}

& .pagination > div > *{
    cursor: pointer;
}

& .pagination > div > .btn{
    position: absolute;
    align-self: center;
    border:none;
    outline:none;
    background-color: transparent;
    display: flex;
    padding:3px;
    font-size: 12px;
    top:0px;
}

& .pagination > div > span{
    /* border:1px solid red; */
    border-radius: 2px;
    font-size: 12px;
    height: 20px;
    width:20px;
    display: flex;
    justify-content: center;
    align-items: center;
}

& .pagination > div > .lBtn{
    left:-10px;
}
& .pagination > div > .rBtn{
    right:-10px;
}
`

